export default __webpack_public_path__ + "static/media/supplier3.d5de98cd.png";